// extracted by mini-css-extract-plugin
export default {"loading":"on-mount-effect_loading__UnuZk"};